import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import Helmet from 'react-helmet'
import { Link } from 'react-router'

// Actions
import { userActions } from 'redux/actionCreators'

// Components
import { FormGroup, Loader } from 'components'

// Styles
import classes from './ForgotPassword.scss'

// Helpers
import _get from 'lodash.get'
import { validateRequired, hasError, inputProps } from 'helpers/formHelpers'

const mapStateToProps = (state) => ({
  attempting: _get(state, ['user', 'setNewPasswordAttempting']) || false,
  attempted: _get(state, ['user', 'setNewPasswordAttempted']) || false
})
const mapDispatchToProps = (dispatch) => ({
  attemptSetNewPassword: (payload) =>
    dispatch(userActions.attemptSetNewPassword(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({ form: 'SetNewPassword', fields: ['newPassword', 'confirmPassword'] })
class SetNewPassword extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    attemptSetNewPassword: PropTypes.func.isRequired,
    attempting: PropTypes.bool.isRequired
  };
  static contextTypes = { router: PropTypes.object.isRequired };

  constructor (props) {
    super(props)
    this.state = {
      newPasswordError: '',
      confirmPasswordError: ''
    }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  _validateInput = () => {
    const { attempting, fields } = this.props
    let error = validateRequired(fields.newPassword.value, 'newPassword')
    error = { ...error, ...validateRequired(fields.confirmPassword.value, 'confirmPassword') }
    if (!error.newPasswordError && !error.confirmPasswordError && fields.newPassword.value !== fields.confirmPassword.value) {
      error = { ...error, newPasswordError: 'รหัสผ่านทั้งสองไม่ตรงกัน', confirmPasswordError: 'รหัสผ่านทั้งสองไม่ตรงกัน' }
    }

    this.setState(error)
    return !attempting && !hasError(error)
  }

  _onSubmit = () => {
    if (this._validateInput()) {
      const { attemptSetNewPassword, location, fields: { newPassword } } = this.props
      attemptSetNewPassword({
        newPassword: newPassword.value,
        resetKey: _get(location, ['query', 'random'])
      })
    }
  }

  _onOkay = () => this.context.router.replace('/');

  render () {
    const { attempting, attempted, fields: { newPassword, confirmPassword } } = this.props
    return (
      <div id='change-password-page' className='page-wrapper'>
        <Helmet title='กำหนดรหัสผ่านใหม่' />
        <div className='hero'>
          <Link to='/'>
            <img className='logo' src='/images/logo.png' alt='logo' />
          </Link>
          <div className='underline' />
        </div>
        <div className={classes.header}>
          <img src='/images/icon-question.png' alt='icon-question' />
          <span>กำหนดรหัสผ่านใหม่</span>
        </div>
        <div className={classes.body}>
          <FormGroup title='รหัสผ่านใหม่' centered errorMessage={this.state.newPasswordError}>
            <input type='password' {...inputProps(newPassword)} />
          </FormGroup>
          <FormGroup title='ยืนยันรหัสผ่านใหม่' centered errorMessage={this.state.confirmPasswordError}>
            <input type='password' {...inputProps(confirmPassword)} />
          </FormGroup>
          <div className={classes.button} onClick={this._onSubmit}>
            {attempting ? <Loader /> : <span>กำหนดรหัสผ่านใหม่</span>}
          </div>
        </div>
        {attempted && (
          <div className='overlay'>
            <div className='overlay-cell'>
              <div className='lightbox'>
                <div className='line1'>
                  <span>การเปลี่ยนแปลงรหัสผ่านสำเร็จ</span>
                </div>
                <div className='line3'>
                  <div>พบปัญหาการใช้งานหรือต้องการสอบถามข้อมูลเพิ่มเติมติดต่อ 063-464-6194, 063-464-6195, 063-464-6196</div>
                  <div>วันจันทร์ - วันเสาร์​เวลา 9.00 - 18.00 น. หรือ Email chatchaipharmacy@gmail.com</div>
                </div>
                <img className='mascot' src='/images/mascot.png' alt='mascot' />
                <div className='btn-close' onClick={this._onOkay}>X</div>
                <div className='btn-ok' onClick={this._onOkay}>
                  <span>ตกลง</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default SetNewPassword



// WEBPACK FOOTER //
// ./src/containers/SetNewPassword.js